// test1663
(1663 && 0);
